import { extractVisitUrl } from '../extractors/common/primitives/extractVisitUrl';
export var getByDefinitionId = function getByDefinitionId(definitionId, store) {
  var urls = Object.keys(store);
  return urls.filter(function (url) {
    var details = store[url].details;
    return details && details.meta.definitionId === definitionId;
  });
};
export var getClickUrl = function getClickUrl(url, jsonLd) {
  if (jsonLd && jsonLd.data) {
    var visitUrl = extractVisitUrl(jsonLd.data);
    if (visitUrl) {
      return visitUrl;
    }
  }
  return url;
};
export var getDefinitionId = function getDefinitionId(details) {
  var _details$meta;
  return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId;
};
export var getExtensionKey = function getExtensionKey(details) {
  var _details$meta2;
  return details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key;
};
export var getResourceType = function getResourceType(details) {
  var _details$meta3;
  return details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.resourceType;
};
export var getProduct = function getProduct(details) {
  var _details$meta4;
  return details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.product;
};
export var getSubproduct = function getSubproduct(details) {
  var _details$meta5;
  return details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.subproduct;
};
export var getServices = function getServices(details) {
  return details && details.meta.auth || [];
};
export var hasResolved = function hasResolved(details) {
  return details && isAccessible(details) && isVisible(details);
};
export var isAccessible = function isAccessible(_ref) {
  var access = _ref.meta.access;
  return access === 'granted';
};
export var isVisible = function isVisible(_ref2) {
  var visibility = _ref2.meta.visibility;
  return visibility === 'restricted' || visibility === 'public';
};
export var getStatusDetails = function getStatusDetails(details) {
  var _details$meta6;
  return details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 || (_details$meta6 = _details$meta6.requestAccess) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.accessType;
};
export var isFinalState = function isFinalState(status) {
  return ['unauthorized', 'forbidden', 'errored', 'resolved', 'not_found'].indexOf(status) > -1;
};
export var getDatasources = function getDatasources(details) {
  return details === null || details === void 0 ? void 0 : details.datasources;
};
export var getCanBeDatasource = function getCanBeDatasource(details) {
  var datasources = getDatasources(details);
  return !!datasources && datasources.length > 0;
};
export var hasAuthScopeOverrides = function hasAuthScopeOverrides(details) {
  return !!(details !== null && details !== void 0 && details.meta.hasScopeOverrides);
};